module.exports = __webpack_public_path__ + "static/media/new-guarantee.7acd038b.svg";